import { modalRedux } from "../../common/components/Modal"

export const modalActions = {
	openModal: ({ headerTitle, type, size, actions, bodyContent }) =>
		modalRedux.modalActions.openModal({ headerTitle, type, size, actions, bodyContent }),
	closeModal: () => modalRedux.modalActions.closeModal()
}